/**
 * Do not index corpo or giftcards.
 * @see https://bigbox.atlassian.net/browse/BIGBOX-8692
 */
/**
 * Index update for above issue
 * @see https://bigbox.atlassian.net/browse/BIGBOX-8715
 */

export function getRobotsByBox(boxInfo) {
  // let isCorpoOrGiftcard = ['12', '138'].includes(boxInfo?.category?.id);

  return !boxInfo?.available
    ? {
        name: 'robots',
        vmid: 'robots',
        content: 'noindex,nofollow',
      }
    : {
        name: 'robots',
        vmid: 'robots',
        content: 'index,follow',
      };
}

export function getRobotsByActivity(activityInfo) {
  const expirationDate = Date.parse(activityInfo.expiration_date);
  const currentDate = Date.now();

  let isOnDate = !expirationDate || expirationDate <= currentDate;
  let isAvailable = activityInfo.available;
  let isVisibleInCatalog = activityInfo.visible_catalog;

  return isOnDate && isVisibleInCatalog && isAvailable
    ? {
        name: 'robots',
        vmid: 'robots',
        content: 'noindex,nofollow',
      }
    : {
        name: 'robots',
        vmid: 'robots',
        content: 'index,follow',
      };
}
